export const SESSION_KEY = "nanomSession";
export const SESSION_TTL_MS = 6 * 60 * 1000;
export const LOGIN_INFO_KEY = "nanomLoginInfo";
export const HAS_REGISTERED_KEY = "nanomHasRegistered";
export const DEVICE_LOCK_KEY = "nanomDeviceLock";

export type Session = {
  sessionToken: string;
  sessionExpiresAt: string;
  sessionTtlSeconds?: number;
  sessionSavedAt?: number;
  username?: string;
  displayName?: string;
  userPublicId?: string;
  blockchainId?: string;
  nanomUserId?: string;
};

export function sessionExpiresAtMs(s: Session | null | undefined): number {
  if (!s) return 0;
  const parsed = s.sessionExpiresAt ? Date.parse(s.sessionExpiresAt) : 0;
  if (Number.isFinite(parsed) && parsed > 0) return parsed;
  return Number(s.sessionSavedAt || 0) + SESSION_TTL_MS;
}

export function isSessionValid(s: Session | null | undefined): boolean {
  return !!(s && s.sessionToken && sessionExpiresAtMs(s) > Date.now());
}

export function loadSession(): Session | null {
  try {
    const raw = JSON.parse(localStorage.getItem(SESSION_KEY) || "null") as Session | null;
    if (!isSessionValid(raw)) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    return raw;
  } catch {
    return null;
  }
}

export function normalizeSession(
  out: Partial<Session> & { sessionToken: string },
  username?: string
): Session {
  const now = Date.now();
  return {
    ...out,
    sessionToken: out.sessionToken,
    username: out.username || username || "",
    sessionSavedAt: now,
    sessionExpiresAt:
      out.sessionExpiresAt || new Date(now + SESSION_TTL_MS).toISOString(),
    sessionTtlSeconds: out.sessionTtlSeconds || 360,
  };
}

export function persistSession(next: Session): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(next));
  localStorage.setItem(
    LOGIN_INFO_KEY,
    JSON.stringify({
      username: next.username || "",
      lastLoginAt: Date.now(),
      userPublicId: next.userPublicId || next.blockchainId || "",
    })
  );
}

export function clearSessionStorage(): void {
  localStorage.removeItem(SESSION_KEY);
}

export function markRegisteredOnce(): void {
  localStorage.setItem(HAS_REGISTERED_KEY, "1");
}
